module.exports = __webpack_public_path__ + "img/flower-06.0268c676.png";